import { useAuth0 } from "@auth0/auth0-react"
import { useSetAtom } from "jotai"
import { userAtom } from "../atoms/user"
import { trackEvent } from "../monitoring/tracking"
import { useLDClient } from "launchdarkly-react-client-sdk"
import { useEffect } from "react"

/* Set user data from Auth0 */
export const useUpdateUser = () => {
	const { user, isAuthenticated, isLoading } = useAuth0();
	const setUser = useSetAtom(userAtom);
	const ldClient = useLDClient();

	useEffect(() => {
		if (isAuthenticated && !isLoading && user) {
			// Auth0 user data structure
			const given_name = user.given_name || user.name?.split(' ')[0] || "Customer";
			const family_name = user.family_name || user.name?.split(' ').slice(1).join(' ') || "";
			const email = user.email || "";
			
			// Check for admin role in Auth0 custom claims
			// Auth0 custom claims are typically namespaced
			const namespace = 'https://portal.ourbluehalo.com/';
			const isAdmin = user[`${namespace}roles`]?.includes('admin') || user[`${namespace}metadata`]?.IsMajorTom || false;
			
			// Update LaunchDarkly context
			const context = {
				kind: "user",
				key: `${email}`,
				name: `${given_name} ${family_name}`.trim(),
				email: `${email}`,
			};
			
			if (ldClient && email) {
				ldClient.identify(context, null);
			}
			
			// Update user atom
			setUser({ given_name, family_name, email, isAdmin });
			
			// Track authentication event
			if (email) {
				trackEvent("User authentication", { 
					name: `${given_name} ${family_name}`.trim(), 
					email: `${email}`,
					provider: 'auth0' 
				});
			}
		}
	}, [user, isAuthenticated, isLoading, setUser, ldClient]);
};